import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAddPage from 'hooks/useAddPage';

const PedidosAddPage = (props) => {
    const app = useApp();

    //form validation rules
    const validationSchema = yup.object().shape({
        tipo: yup.string().required().label("Tipo"),
        dt: yup.string().required().label("Data/Hora"),
        funcid: yup.string().required().label("Funcionário"),
        status: yup.string().nullable().label("Status")
    });

    //form default values
    const formDefaultValues = {
        tipo: 'P',
        dt: new Date(),
        funcid: '',
        status: 'A',
    }

    //page hook where logics resides
    const pageController = useAddPage({ props, formDefaultValues, afterSubmit });

    // destructure and grab what the page needs
    const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;

    //event raised after form submit
    function afterSubmit(response) {
        app.flashMsg(props.msgTitle, props.msgAfterSave);
        resetForm();
        if (app.isDialogOpen()) {
            app.closeDialogs(); // if page is open as dialog, close dialog
        }
        else if (props.redirect) {
            app.navigate(`/pedidos`);
        }
    }

    // page loading form data from api
    if (loading) {
        return (
            <div className="p-3 text-center">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} />
            </div>
        );
    }

    //page has loaded any required data and ready to render
    if (pageReady) {
        return (
            <main id="PedidosAddPage" className="main-page">
                {(props.showHeader) &&
                    <section className="page-section mb-3" >
                        <div className="container">
                            <div className="grid justify-content-between align-items-center">
                                {!props.isSubPage &&
                                    <div className="col-fixed " >
                                        <Button onClick={() => app.navigate(-1)} label="" className="p-button p-button-text " icon="pi pi-arrow-left" />
                                    </div>
                                }
                                <div className="col " >
                                    <Title title="Adicionar novo" titleClass="text-2xl text-primary font-bold" subTitleClass="text-500" separator={false} />
                                </div>
                            </div>
                        </div>
                    </section>
                }
                <section className="page-section " >
                    <div className="container">
                        <div className="grid ">
                            <div className="md:col-9 sm:col-12 comp-grid" >
                                <div >
                                    <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) => submitForm(values)}>
                                        {(formik) =>
                                            <>
                                                <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                                    <div className="grid">

                                                        <div className="md:col-4 col-12">
                                                            Tipo *
                                                            <div>
                                                                <Dropdown name="tipo" optionLabel="label" optionValue="value" value={formik.values.tipo} onChange={formik.handleChange} options={app.menus.tipo2} label="Tipo" placeholder="Selecione um valor ..." className={inputClassName(formik?.errors?.tipo)} />
                                                                <ErrorMessage name="tipo" component="span" className="p-error" />
                                                            </div>
                                                        </div>
                                                        <div className="md:col-4 col-12">
                                                            Data/Hora *
                                                            <div>
                                                                <Calendar name="dt" value={formik.values.dt} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24" showIcon className={inputClassName(formik?.errors?.dt)} />
                                                                <ErrorMessage name="dt" component="span" className="p-error" />
                                                            </div>
                                                        </div>
                                                        <div className="md:col-8 col-12">
                                                            Funcionário *
                                                            <div>
                                                                <DataSource apiPath="components_data/funcid_option_list"  >
                                                                    {
                                                                        ({ response }) =>
                                                                            <>
                                                                                <Dropdown name="funcid" optionLabel="label" optionValue="value" value={formik.values.funcid} onChange={formik.handleChange} options={response} label="Funcionário" placeholder="Selecione um valor ..." className={inputClassName(formik?.errors?.funcid)} />
                                                                                <ErrorMessage name="funcid" component="span" className="p-error" />
                                                                            </>
                                                                    }
                                                                </DataSource>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {props.showFooter &&
                                                        <div className="text-center my-3">
                                                            <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Enviar" icon="pi pi-send" loading={saving} />
                                                        </div>
                                                    }
                                                </Form>
                                            </>
                                        }
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}

//page props and default values
PedidosAddPage.defaultProps = {
    primaryKey: 'id',
    pageName: 'inventario',
    apiPath: 'pedidos/add',
    routeName: 'pedidosadd',
    submitButtonLabel: "Enviar",
    formValidationError: "O formulário é inválido",
    formValidationMsg: "Por favor, preencha o formulário",
    msgTitle: "Criar registro",
    msgAfterSave: "Registro adicionado com sucesso",
    msgBeforeSave: "Deseja Salvar os Dados Agora?",
    showHeader: true,
    showFooter: true,
    redirect: true,
    isSubPage: false
}
export default PedidosAddPage;
